import MailboxOptions from 'owa-service/lib/contract/MailboxOptions';
import store from '../store/store';

export default function getMailboxForwardingConfiguration(): MailboxOptions {
    return store.mailboxForwardingConfiguration;
}
